import { IconFont, SignTitle, SvgIcon, TableTag, TagDetail } from '@/components'
import { Modal, Spin, Tag } from 'antd'
import styled from 'styled-components'
import { useGetTemplateDetail } from './utils'
import { useEffect } from 'react'
import MarkdownEditor from '@/components/markdown-editor'
import { t } from '@/i18n'

export const DetailModal = props => {
  const { setVisible, id } = props
  const [detail, getDetail, detailLoading] = useGetTemplateDetail()

  useEffect(() => {
    getDetail({ id }).catch(_ => {})
  }, [])
  return (
    <TaskTemplate
      visible
      centered
      title={<SignTitle show>{t('模板详情')}</SignTitle>}
      footer={false}
      width={700}
      onOk={() => {
        setVisible()
      }}
      onCancel={() => {
        setVisible()
      }}
    >
      {detailLoading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <Spin />
        </div>
      ) : (
        <div>
          <div className="flex">
            {detail.origin_type === 1 ? (
              <TableTag background="#558492" color="#fff" style={{ padding: '3px 4px' }}>
                {t('系统内置')}
              </TableTag>
            ) : (
              <TableTag background="#ED787E" color="#fff" style={{ padding: '3px 4px' }}>
                {t('自定义')}
              </TableTag>
            )}
            <div className="headline">{detail.name}</div>
          </div>
          <div className="file-format flex">
            <div className="title">{t('文件格式：')}</div>
            <div className="text">
              <div className="value">{detail.format_name}</div>
            </div>
          </div>
          {detail?.resource_tag_list && detail?.resource_tag_list?.length > 0 && (
            <TagDetail resourceTagList={detail?.resource_tag_list} />
          )}
          {detail?.tactics?.length > 0 && (
            <div className="flex" style={{ marginTop: '24px', alignItems: 'flex-start' }}>
              <span className="title" style={{ width: '115px' }}>
                ATT&CK：
              </span>
              <div style={{ width: '295px' }}>
                {detail?.tactics?.map(item => (
                  <div key={item.id} style={{ marginBottom: '6px' }}>
                    {item.name}
                  </div>
                ))}
              </div>
            </div>
          )}
          {detail.describe && (
            <div style={{ marginBottom: 16 }}>
              <div className="title" style={{ marginBottom: 16 }}>
                {t('描述：')}
              </div>
              <MarkdownEditor
                isEdit={false}
                onlyDisplay
                setValue={() => {}}
                value={detail.describe}
              />
            </div>
          )}

          {detail?.file_type === 4 ? (
            <div>
              <div className="title" style={{ marginBottom: 16 }}>
                {t('数据内容：')}
              </div>
              <div>
                <IconFont type="icon-047-file" />
                <span style={{ lineHeight: 1.2, marginLeft: 12 }}>{detail.file_name}</span>
              </div>
            </div>
          ) : (
            <div className="flex">
              <div style={{ flex: 1 }}>
                <div className="title">{t('数据内容：')}</div>
                <div className="data-content">{detail?.content}</div>
              </div>
              <div style={{ marginLeft: 10, flex: 1 }}>
                <div className="title">{t('动态生成数据的变量：')}</div>
                <div className="data-content">
                  {detail?.variable_list?.map((item, index) => (
                    <div key={index}>{`${item}`}</div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </TaskTemplate>
  )
}
const TaskTemplate = styled(Modal)`
  .ant-modal-body {
    overflow: scroll;
    height: 605px;
  }
  .flex {
    display: flex;
    align-items: center;
    .headline {
      font-weight: bold;
      margin-left: 4px;
    }
  }
  .title {
    font-size: 14px;
    color: #86909c;
    width: 70px;
    height: 16px;
    line-height: 16px;
    display: inline-block;
  }
  .file-format {
    margin: 21px 0 24px 0;
  }
  .title {
    color: #666;
  }
  .describe {
    height: 126px;
    background: #f8f9fb;
    border-radius: 8px;
    margin-top: 12px;
    padding: 14px;
    overflow-y: scroll;
    margin-bottom: 24px;
    line-height: 20px;
  }
  .data-content {
    margin-top: 12px;
    width: 305px;
    height: 261px;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 14px;
    overflow-y: scroll;
    line-height: 20px;
  }
`
const Svg = styled(SvgIcon)`
  width: 20px;
  height: 22px;
`
